module.exports = __webpack_public_path__ + "img/Feature.c868475c.jpg";